var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popup-component":_vm.popupComponent,"title":"Admin List","icon":"mdi-handshake","addButtonText":"Admin","stateendpoint":"adminUsers","actions":_vm.actions,"basic-data":_vm.basicData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }